import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        this.toggleDetails()
    }

    toggleDetails() {
        const selected = this.element.querySelector('input[name="payment_method"]:checked')?.value

        // Elements
        const flouciDetails = this.element.querySelector('#flouci-details')
        const d17Details = this.element.querySelector('#d17-details')
        const bankDetails = this.element.querySelector('#bank-details')
        const flouciSecurityNote = this.element.querySelector('#flouci-security-note')

        // Hide all first
        if (flouciDetails) flouciDetails.classList.add('hidden')
        if (d17Details) d17Details.classList.add('hidden')
        if (bankDetails) bankDetails.classList.add('hidden')
        if (flouciSecurityNote) flouciSecurityNote.classList.add('hidden')

        // Remove active state classes from labels
        this.element.querySelectorAll('input[name="payment_method"]').forEach(radio => {
            const label = radio.closest('label')
            label.classList.remove('bg-blue-50', 'border-blue-200')
            label.classList.add('hover:bg-gray-50')
        })

        // Show active and style its label
        const activeRadio = this.element.querySelector('input[name="payment_method"]:checked')
        if (activeRadio) {
            const activeLabel = activeRadio.closest('label')
            activeLabel.classList.remove('hover:bg-gray-50')
            activeLabel.classList.add('bg-blue-50', 'border-blue-200')

            if (selected === 'flouci') {
                if (flouciDetails) flouciDetails.classList.remove('hidden')
                if (flouciSecurityNote) flouciSecurityNote.classList.remove('hidden')
            } else if (selected === 'd17') {
                if (d17Details) d17Details.classList.remove('hidden')
            } else if (selected === 'bank_transfer') {
                if (bankDetails) bankDetails.classList.remove('hidden')
            }
        }
    }
}
